<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { supabase } from '@/lib/supabase'
import { onMounted, ref } from 'vue'

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const error = ref<string | null>(null)


onMounted(async () => {
  if (route.query.code) {
    try {
      const { data, error } = await supabase.auth.exchangeCodeForSession(route.query as any)
      
      if (error) {
        console.log("Error confirming email :(")
        router.push("/home")
      } else {
        router.push("/home")
      }
    } catch (err) {
      router.push("/home")
    }
  }
})

</script>

<template>
  <div class="auth-callback">
    <div v-if="loading">
      <p>Confirming your email...</p>
    </div>
    <div v-else-if="error" class="error">
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<style scoped>
.auth-callback {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  text-align: center;
  background-color: white;
}

.error {
  color: #ef4444;
}
</style>